import { combineReducers } from 'redux'

import { makeCommunicationReducer } from 'shared/utils/communication/reducer/makeCommunicationReducer'
import { IBonusHistoryState } from '../types'

import * as actions from '../actions'

export default combineReducers<IBonusHistoryState['communications']>({
  getBonusHistory: makeCommunicationReducer(actions.getBonusHistory),
  getCashbackHistory: makeCommunicationReducer(actions.getCashbackHistory)
})
